/**
 * Shared look for the shop's cards (products, collections, articles):
 * a borderless white card that lifts on hover, a photo frame inside it,
 * and a round arrow that fills on hover.
 */
import { ArrowUpRight } from "lucide-react";
import { cn } from "@ui/lib/utils";

export const cardSurface =
  "group flex flex-col rounded-3xl bg-white p-2.5 transition-[opacity,box-shadow,translate] duration-300 ease-out hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-20px_rgb(0_0_0/0.3)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary motion-reduce:hover:translate-y-0";

/** Photo frame inside a card: radius matches the card's inner corner. */
export const cardMedia = "relative overflow-hidden rounded-[14px] bg-white";

export function CardArrow({ className }: Readonly<{ className?: string }>) {
  return (
    <span
      className={cn(
        "flex size-8 shrink-0 items-center justify-center rounded-full bg-background-6 text-text-1 transition-colors duration-200 group-hover:bg-primary group-hover:text-white",
        className,
      )}
      aria-hidden="true"
    >
      <ArrowUpRight className="size-4" strokeWidth={2} />
    </span>
  );
}
